const theme = {
  themes: {
    light: {
      primary: "#354093", //primary blue
      secondary: "#f5a04e", //primary yellow
      tertiary: "#f8e5ee", //secondary pink
      accent: "#65c1be", //secondary green
      error: "#ff4d4f",
      success: "#52c41a",
    },
  },
};

export default theme;



// WEBPACK FOOTER //
// ./src/styles/theme.js